import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormValidator } from '../../helpers/form-validator';
import { Modal, Button, Form, FormControl, FormLabel, Alert } from 'react-bootstrap';
import { Validator, Heading5, TitleIcon } from '../widgets';
import { changePassword } from '../../actions/users';

const getValidationRules = (passwordInfo) => {
    const isPasswordMatched = value => passwordInfo.newPassword !== value;

    return [
        {
            field: 'currentPassword',
            method: 'isEmpty',
            validWhen: false,
            message: 'Current Password is required.',
        },
        {
            field: 'newPassword',
            method: 'isEmpty',
            validWhen: false,
            message: 'New Password is required.',
        },
        {
            field: 'confirmPassword',
            method: 'isEmpty',
            validWhen: false,
            message: 'Confirm Password is required.',
        },
        {
            field: 'confirmPassword',
            method: isPasswordMatched,
            validWhen: false,
            message: "Confirm password doesn't match with password.",
        },
    ]
};

const ChangePassword = (props) => {
    const { actions, onHide } = props;
    const [errorMessage, setErrorMessage] = useState(null);
    const [isChanging, setIsChanging] = useState(false);
    const [passwordInfo, setPasswordInfo] = useState({ currentPassword: null, newPassword: null, confirmPassword: null });

    const validator = new FormValidator(getValidationRules(passwordInfo));
    const [validationInfo, setValidationInfo] = useState({ validation: validator.valid(), submitted: false });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPasswordInfo({ ...passwordInfo, [name]: value.length > 0 ? value : null });
    };

    const handleSave = () => {
        setErrorMessage(null);
        const validation = validator.validate(passwordInfo);
        setValidationInfo({ validation, submitted: true });

        const params = {
            current_password: passwordInfo.currentPassword,
            new_password: passwordInfo.newPassword,
        };

        if (validation.isValid) {
            setIsChanging(true);
            const cb = (isSuccess, error) => {
                setIsChanging(false);
                if (isSuccess) onHide();
                else setErrorMessage(error);
            };
            actions.changePassword(params, cb);
        }
    };

    const Validation = validationInfo.submitted ? validator.validate(passwordInfo) : validationInfo.validation;

    return (
        <Modal show={true} backdrop="static" onHide={onHide} size='md'>
            <Modal.Header closeButton style={{ color: '#064d9e' }}>
                <Modal.Title >
                    <Heading5>
                        <TitleIcon className="fa fa-unlock-alt" />
                        Change Password
                    </Heading5>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {errorMessage && <div className="password-form-alert">
                    <Alert show={true} variant="danger" onClose={() => setErrorMessage(null)} dismissible>{errorMessage}</Alert>
                </div>}
                <Form autoComplete="off" >
                    <Form.Group  >
                        <Validator validation={Validation.currentPassword}>
                            <FormLabel >Current Password<Validator.Mand /></FormLabel>
                            <FormControl
                                size='sm' autoComplete='off' type="password" placeholder='Current Password'
                                name='currentPassword' value={passwordInfo.currentPassword || ""}
                                onChange={handleChange}
                            />
                            <Validator.Text />
                        </Validator>
                    </Form.Group>
                    <Form.Group  >
                        <Validator validation={Validation.newPassword}>
                            <FormLabel >New Password<Validator.Mand /></FormLabel>
                            <FormControl
                                size='sm' autoComplete='off' type="password" placeholder='New Password'
                                name='newPassword' value={passwordInfo.newPassword || ""}
                                onChange={handleChange}
                            />
                            <Validator.Text />
                        </Validator>
                    </Form.Group>
                    <Form.Group  >
                        <Validator validation={Validation.confirmPassword}>
                            <FormLabel >Confirm Password<Validator.Mand /></FormLabel>
                            <FormControl
                                size='sm' autoComplete='off' type="password" placeholder='Confirm Password'
                                name='confirmPassword' value={passwordInfo.confirmPassword || ""}
                                onChange={handleChange}
                            />
                            <Validator.Text />
                        </Validator>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='btn btn-danger btn-sm ' onClick={() => onHide()} ><i className="fa fa-times-circle"></i> Cancel</Button>{' '}
                <Button variant='btn btn-primary btn-sm' onClick={handleSave} >{isChanging ? "Changing..." : "Change"}</Button>
            </Modal.Footer>
        </Modal>
    )
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ changePassword }, dispatch)
});

export default connect(null, mapDispatchToProps)(ChangePassword);